import httpclient from '../base/httpclient';
import DIApi from './_diApi';

class BudgetChapterAPI extends DIApi {
  controllerName = 'BudgetChapters';

    /**
    * Chuyển chương hạch toán
    * @returns
    */
    async transderBudgetChapter(fromChapter, toChapter, hasPeriod, from, to) {
      const apiUrl = this.getAPIUrl();
  
      const request = {
        url: apiUrl + '/transferChapter',
        data: {
          fromChapter: fromChapter,
          toChapter: toChapter,
          hasPeriod: hasPeriod,
          fromDate: from,
          toDate: to
        },
      };
  
      return await httpclient.getAsync(request);
    }
}

export default new BudgetChapterAPI();
